import "@/index.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { useEffect } from "react";
import { Layout } from "./components/layout/Layout";
import { Home } from "./pages/Home";
import { About } from "./pages/About";
import { Services } from "./pages/Services";
import { Pricing } from "./pages/Pricing";
import { Contact } from "./pages/Contact";
import { Quote } from "./pages/Quote";
import { FAQ } from "./pages/FAQ";
import { Portfolio } from "./pages/Portfolio";
import { Blog } from "./pages/Blog";
import {
  LegalNotice,
  PrivacyPolicy,
  CookiesPolicy,
  Licenses,
} from "./pages/Legal";
import ScrollToTop from "./components/scrollToTop";
import ServiceDetail from "./pages/ServiceDetail";

import AlmaFleurSA from "./realisations/AlmaFleurSA";
import AtelierDuPendu from "./realisations/AtelierDuPendu";
import BaumeShop from "./realisations/BaumeShop";
import BrasserieCarougeoise from "./realisations/BrasserieCarougeoise";
import LegersCoffee from "./realisations/LegersCoffee";
import LesNocesDeGingko from "./realisations/LesNocesDeGingko";
import PlayRyvenoxGaming from "./realisations/PlayRyvenoxGaming";
import RoyalFortune from "./realisations/RoyalFortune";
import WeblaxStudio from "./realisations/WeblaxStudio";
import BaumeApp from "./realisations/BaumeApp";
import SanteEquilibre from "./realisations/SanteEquilibre";

function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    if (!window.gtag) return;

    window.gtag("event", "page_view", {
      page_title: document.title,
      page_path: location.pathname + location.search,
      page_location: window.location.href,
    });
  }, [location]);

  return null;
}

function PublicRoutes() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/a-propos" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/services/:slug" element={<ServiceDetail />} />
        <Route path="/tarifs" element={<Pricing />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/devis" element={<Quote />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/realisations" element={<Portfolio />} />
        <Route path="/blog" element={<Blog />} />

        <Route path="/mentions-legales" element={<LegalNotice />} />
        <Route path="/confidentialite" element={<PrivacyPolicy />} />
        <Route path="/cookies" element={<CookiesPolicy />} />
        <Route path="/licences" element={<Licenses />} />

        <Route path="/realisations/alma-fleur-sa" element={<AlmaFleurSA />} />
        <Route path="/realisations/atelier-du-pendu" element={<AtelierDuPendu />} />
        <Route path="/realisations/baume-shop" element={<BaumeShop />} />
        <Route
          path="/realisations/brasserie-carougeoise"
          element={<BrasserieCarougeoise />}
        />
        <Route path="/realisations/legers-coffee" element={<LegersCoffee />} />
        <Route
          path="/realisations/les-noces-de-gingko"
          element={<LesNocesDeGingko />}
        />
        <Route path="/realisations/play-ryvenox-gaming" element={<PlayRyvenoxGaming />} />
        <Route path="/realisations/royal-fortune" element={<RoyalFortune />} />
        <Route path="/realisations/weblax-studio" element={<WeblaxStudio />} />
        <Route path="/realisations/baume-app" element={<BaumeApp />} />
        <Route path="/realisations/sante-equilibre" element={<SanteEquilibre />} />

        <Route path="*" element={<Home />} />
      </Routes>
    </Layout>
  );
}

function AppContent() {
  const location = useLocation();
  const isAdminPath =
    location.pathname.startsWith("/admin") ||
    location.pathname.startsWith("/admin-login");

  return isAdminPath ? <AdminRoutes /> : <PublicRoutes />;
}

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <ScrollToTop />
        <AnalyticsTracker />
        <AppContent />
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;